module.exports = __webpack_public_path__ + "static/media/facebook.27673f4e.svg";